<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import {Storage} from '@/utils/common';
export default {
  name: 'App',
  mounted() {
    const token = Storage.get('token');
    if (token) {
      this.$store.dispatch('routerV/getMenuList', this.userInfo.id);
    }
  }
};
</script>
